define(["exports", "@babel/runtime/helpers/esm/extends", "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose", "react", "styled-components", "../../themes"], function (_exports, _extends2, _objectWithoutPropertiesLoose2, _react, _styledComponents, _themes) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

  var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Checkbox = void 0;
  _extends2 = _interopRequireDefault(_extends2);
  _objectWithoutPropertiesLoose2 = _interopRequireDefault(_objectWithoutPropertiesLoose2);
  _react = _interopRequireWildcard(_react);
  _styledComponents = _interopRequireWildcard(_styledComponents);
  var _excluded = ["id", "alignLabelRight", "disabled", "error", "label", "toggle", "checked"];

  var CheckboxStyled = _styledComponents.default.label.withConfig({
    displayName: "Checkbox__CheckboxStyled",
    componentId: "sc-196y8eg-0"
  })(["align-items:center;cursor:pointer;display:flex;position:relative;", ";"], function (_ref) {
    var alignLabelRight = _ref.alignLabelRight;
    return alignLabelRight && (0, _styledComponents.css)(["flex-direction:row-reverse;justify-content:flex-end;"]);
  });

  var checkboxSize = 16;

  var CustomCheckbox = _styledComponents.default.span.withConfig({
    displayName: "Checkbox__CustomCheckbox",
    componentId: "sc-196y8eg-1"
  })(["", ";border-radius:4px;flex-shrink:0;", " ", " input{", ";opacity:0;position:absolute;top:0;}svg{display:block;fill:", ";height:100%;transition:fill 0.2s ", ";width:100%;", ";", ";", ";}.svg-check{opacity:0;transform-origin:50% 50%;", ";}"], (0, _themes.size)(checkboxSize), function (_ref2) {
    var focus = _ref2.focus;
    return focus && (0, _styledComponents.css)(["box-shadow:0 0 2px 1px ", ";"], function (_ref3) {
      var theme = _ref3.theme;
      return theme.colors.blue;
    });
  }, function (_ref4) {
    var focus = _ref4.focus,
        error = _ref4.error;
    return focus && error && (0, _styledComponents.css)(["box-shadow:0 0 2px 1px ", ";"], function (_ref5) {
      var theme = _ref5.theme;
      return theme.colors.red;
    });
  }, (0, _themes.size)(checkboxSize + 4), function (_ref6) {
    var theme = _ref6.theme;
    return theme.colors.dark;
  }, function (_ref7) {
    var theme = _ref7.theme;
    return theme.easing.ease;
  }, function (_ref8) {
    var checked = _ref8.checked;
    return checked && (0, _styledComponents.css)(["fill:", ";"], function (_ref9) {
      var theme = _ref9.theme;
      return theme.colors.orange;
    });
  }, function (_ref10) {
    var error = _ref10.error;
    return error && (0, _styledComponents.css)(["fill:", ";"], function (_ref11) {
      var theme = _ref11.theme;
      return theme.colors.red;
    });
  }, function (_ref12) {
    var disabled = _ref12.disabled;
    return disabled && (0, _styledComponents.css)(["fill:", ";"], function (_ref13) {
      var theme = _ref13.theme;
      return theme.colors.gray;
    });
  }, function (_ref14) {
    var checked = _ref14.checked;
    return checked && (0, _styledComponents.css)(["opacity:1;"]);
  });

  var LabelStyled = _styledComponents.default.span.withConfig({
    displayName: "Checkbox__LabelStyled",
    componentId: "sc-196y8eg-2"
  })(["color:", ";display:block;font-size:1.6em;margin-left:8px;width:100%;", ";", ";", ";"], function (_ref15) {
    var theme = _ref15.theme;
    return theme.colors.dark;
  }, function (_ref16) {
    var alignLabelRight = _ref16.alignLabelRight;
    return alignLabelRight && (0, _styledComponents.css)(["margin-left:0;margin-right:8px;"]);
  }, function (_ref17) {
    var error = _ref17.error,
        theme = _ref17.theme;
    return error && (0, _styledComponents.css)(["color:", ";"], theme.colors.red);
  }, function (_ref18) {
    var disabled = _ref18.disabled,
        theme = _ref18.theme;
    return disabled && (0, _styledComponents.css)(["color:", ";"], theme.colors.darkGray);
  });

  var Checkbox = function Checkbox(_ref19) {
    var id = _ref19.id,
        alignLabelRight = _ref19.alignLabelRight,
        disabled = _ref19.disabled,
        error = _ref19.error,
        label = _ref19.label,
        toggle = _ref19.toggle,
        checked = _ref19.checked,
        rest = (0, _objectWithoutPropertiesLoose2.default)(_ref19, _excluded);

    var _useState = (0, _react.useState)(false),
        focus = _useState[0],
        setFocus = _useState[1];

    return /*#__PURE__*/_react.default.createElement(CheckboxStyled, {
      alignLabelRight: alignLabelRight,
      error: error
    }, /*#__PURE__*/_react.default.createElement(CustomCheckbox, {
      checked: checked,
      error: error,
      disabled: disabled,
      focus: focus
    }, /*#__PURE__*/_react.default.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16"
    }, /*#__PURE__*/_react.default.createElement("g", {
      fillRule: "nonzero"
    }, /*#__PURE__*/_react.default.createElement("path", {
      className: "svg-box",
      d: "M2.286 0A2.288 2.288 0 0 0 0 2.286v11.428A2.288 2.288 0 0 0 2.286 16h11.428A2.288 2.288 0 0 0 16 13.714V2.286A2.288 2.288 0 0 0 13.714 0H2.286zm0 13.714V2.286h11.428l.003 11.428H2.286z"
    }), /*#__PURE__*/_react.default.createElement("path", {
      className: "svg-check",
      d: "M6.853 8.635L5.37 7.183l-1.6 1.634 3.09 3.025 5.371-5.315-1.607-1.625z"
    }))), /*#__PURE__*/_react.default.createElement("input", (0, _extends2.default)({
      type: "checkbox",
      id: id,
      disabled: disabled,
      onChange: toggle,
      "aria-checked": checked,
      onFocus: function onFocus() {
        return setFocus(true);
      },
      onBlur: function onBlur() {
        return setFocus(false);
      },
      checked: checked
    }, rest))), /*#__PURE__*/_react.default.createElement(LabelStyled, {
      alignLabelRight: alignLabelRight,
      error: error,
      disabled: disabled
    }, label));
  };

  _exports.Checkbox = Checkbox;
  Checkbox.defaultProps = {
    alignLabelRight: false
  };
});